import { AdminLayout } from '@/components/Layout';
import React, { useState } from 'react';
import { resolveQuery, useGetUserQueries } from '../../api/getQueries';
import i18next from 'i18next';
import TableLoader from '@/components/Elements/Loader/TableLoader';
import { Button, Table } from '@/components/Elements';

const Queries = () => {
  const { data, isLoading, isFetching, refetch } = useGetUserQueries();
  const [loading, setLoading] = useState(false);
  const [queryId, setQueryId] = useState<number>();
  const handleResolveQuery = async (id: number) => {
    try {
      setLoading(true);
      setQueryId(id);
      await resolveQuery({ query_id: id, status: 'resolved' });
      refetch();
    } catch (error) {
      console.error('Error resolving query:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout title="Queries Raised">
      {isLoading || isFetching ? (
        <TableLoader />
      ) : (
        <Table
          page={parseInt('1')}
          changePage={() => {}}
          total={data?.total ?? 0}
          data={data?.queries ?? []}
          columns={[
            { title: `${i18next.t('Customer Name')}`, field: 'full_name' },
            { title: `${i18next.t('Email')}`, field: 'email' },
            { title: `${i18next.t('Phone')}`, field: 'phone' },
            { title: `${i18next.t('Interest')}`, field: 'interset_in' },
            { title: `${i18next.t('Query')}`, field: 'query' },
            {
              title: `${i18next.t('Action')}`,
              field: 'id',
              Cell({ entry: { id, status } }) {
                return (
                  <>
                    {status === 'pending' ? (
                      <Button
                        isLoading={id === queryId ? true : false}
                        onClick={() => handleResolveQuery(id)}
                      >
                        Resolve
                      </Button>
                    ) : (
                      <Button disabled>Resolved</Button>
                    )}
                  </>
                );
              },
            },
          ]}
        />
      )}
    </AdminLayout>
  );
};

export default Queries;
